'use strict';
import isMobile from "./is_mobile";

const Slider = (function(){
    const supportsSmoothScroll = window.CSS.supports('scroll-behavior', 'smooth');

    return function(el, options) {
        const config = {
            'threshold': 20,
            'bullets': true,
            'arrows': true,
            'speed': 300
        };

        if (options)
            for (const k in config)
                if (options.hasOwnProperty(k))
                    config[k] = options[k];

        const container = typeof el === 'string' ? document.querySelector(el) : el;
        const frame = container.children[0];
        const arrows = config['arrows'] ? container.appendChild(document.createElement('div')) : null;
        const bullets = config['bullets'] ? container.appendChild(document.createElement('div')) : null;
        const slides = [].slice.call(frame.children);
        let currentSlide;
        let containerWidth = 0;

        let throttled = false;
        let debouncer;
        let limit = {
            min: 0,
            max: slides.length - 1
        }

        if (arrows) {
            arrows.classList.add('slider-arrows');
            arrows.innerHTML = '<i data-nav="-1"></i><i data-nav="1"></i>'
        }

        if (bullets) {
            bullets.classList.add('slider-bullets');
            let bulletsHtml = '';
            for (let i = 0; i <= limit.max; i++)
                bulletsHtml += '<i></i>';
            bullets.innerHTML = bulletsHtml;
        }

        const resizeHandler = () => {
            if (containerWidth !== container.offsetWidth) {
                containerWidth = container.offsetWidth;
            }
        };

        const emitSlide = () => {
            if (slides[currentSlide]) {
                slides[currentSlide].dispatchEvent(new Event('slide', {bubbles: true, cancelable: false}))
            }
        }

        const slide = (val, skipAnimation) => {
            let nextSlide = (currentSlide || 0) + val;
            let smooth = true;

            if (nextSlide < limit.min) {
                nextSlide = limit.max
                smooth = false
            } else if (nextSlide > limit.max) {
                nextSlide = limit.min;
                smooth = false;
            }

            if (supportsSmoothScroll && !skipAnimation && smooth ) {
                frame.scroll({
                    left: containerWidth * nextSlide,
                    top: 0,
                    behavior: 'smooth'
                })
            } else {
                frame.scrollLeft = containerWidth * nextSlide;
            }

            handleNavigation(nextSlide);
            emitSlide();
        };

        const onScroll = (e) => {
            e.stopImmediatePropagation();
            if (e.ctrlKey) {
                e.preventDefault();
                return false;
            }
            clearTimeout(debouncer);
            if (!throttled) {
                throttled = true;
                window.requestAnimationFrame(function() {
                    const scrollLeft = frame.scrollLeft;
                    const slide = Math.round(scrollLeft / containerWidth);
                    handleNavigation(slide);
                    if (slide * containerWidth === scrollLeft) {
                        emitSlide();
                    }
                    throttled = false;
                })
            }
        }
        const handleNavigation = (slide) => {
            if (bullets) {
                bullets.childNodes.forEach(function(el, index) {
                    el.classList.toggle('active', index === this)
                }, slide);
            }

            if (arrows) {
                if (arrows.childNodes[0]) {
                    arrows.childNodes[0].toggleAttribute('disabled', slide === limit.min);
                }
                if (arrows.childNodes[1]) {
                    arrows.childNodes[1].toggleAttribute('disabled', slide === limit.max);
                }
            }
            if (currentSlide === slide) {
                return;
            }
            currentSlide = slide;
        }

        const toggleEvents = (toggle) => {
            if (!isMobile) {
                return;
            }
            if (toggle) {
                frame.addEventListener('scroll', onScroll);
            } else {
                frame.removeEventListener('scroll', onScroll);
            }
        }

        window.addEventListener('resize', resizeHandler);

        resizeHandler();
        handleNavigation(0);
        toggleEvents(true);
        if (arrows) {
            arrows.addEventListener('click', (e) => slide(parseInt(e.target.dataset.nav)));
        }

        return {
            'slideTo': (val, animate) => { currentSlide = parseInt(val); slide(0, !animate); },
            'currentSlide': () => currentSlide,
            'reposition': resizeHandler,
            'toggleEvents': toggleEvents,
        }
    };
})();

export default Slider;